import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../_utils/config';
import { 
   Table, Menu,
   Loader,Input, Pagination,Header,Segment
} from 'semantic-ui-react';
import _ from 'lodash';
import printJS from 'print-js';
import { fetchOPD } from '../../../../_utils/localstorage';

export default class AllOPD extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         data: [],
         result: [],
         result_search:[],
         direction: null,
         requests:false,
         query:"",

         activePage:1,
         totalPages:0,
         itemPerPage:10,
         page:1,
         startfrom:0,
         pageActive: 1,
         
      }

      this.printDocument = this.printDocument.bind(this);
   }

   printDocument() {
      printJS({
         printable:'data_print', 
         type:'html', 
         showModal:true
      })
   }

   handleSort = clickedColumn => () => {
      const { column, result, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            result: _.sortBy(result, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         result: result.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }

   
   getData(){
      this.setState({requests:true});            
      fetch(`${BaseURLDev}/simantra/ref/allopd`, { headers })
      .then(response => {
         if(!response.ok){
            window.alert("Load data gagal")            
            this.setState({data:[],requests:false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => {
         const startfrom = (this.state.page-1)*this.state.itemPerPage;
         var { skpd, user } = JSON.parse(sessionStorage.data);
         sessionStorage.setItem('data', JSON.stringify({
            user: user,
            skpd: skpd,
            opd: resJSON.data
         }))

         this.setState({
            totalPages:Math.ceil(resJSON.data.length/this.state.itemPerPage),
            data:resJSON.data,
            result:resJSON.data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false,
            startfrom:startfrom
         })
      })
      
   }
   
   handlePaginationChange = (e, { activePage }) => {
      if (this.state.pageActive === activePage){
         return false;
      }

      this.setState({ activePage, pageActive: activePage, requests: true })
      if(this.state.query===""){
         const startfrom = (activePage-1)*this.state.itemPerPage
         this.setState({
            startfrom:startfrom,
            result:this.state.data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false
         })
      }else{
         const startfrom = (activePage-1)*this.state.itemPerPage
         this.setState({
            startfrom:startfrom,
            result:this.state.result_search.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false
         })
      }
   }

   handleFetchOPD(){
      const startfrom = (this.state.page-1)*this.state.itemPerPage
      this.setState({
         totalPages:Math.ceil(fetchOPD().length/this.state.itemPerPage),
         data:fetchOPD(),
         result:fetchOPD().slice(startfrom,startfrom+this.state.itemPerPage),
         startfrom:startfrom
      })
   }

   componentDidMount(){
      if(fetchOPD().length!==0){
         this.handleFetchOPD()
      }else{
         this.getData();
      }
   }

   searchData(e){
      const query = (e.target.value).toLowerCase()
      const { data } = this.state
      this.setState({query:query,requests:true});      
      if(query.length>0){
         var results = [];
         for(let i=0; i<data.length; i++) {
            for(let key in data[i]) {
               if(data[i][key].toLowerCase().indexOf(query)!==-1) {
                  results.push(data[i]);
               }
            }
         }
         // this.setState({ activePage })
         const startfrom = (this.state.page - 1) * this.state.itemPerPage
         this.setState({
            totalPages: Math.ceil(results.length/this.state.itemPerPage),
            // data:resJSON.data,
            result_search: results,
            result: results.slice(startfrom,startfrom+this.state.itemPerPage),
            requests: false,
            startfrom: startfrom
         })
         // this.setState({result:results, requests:false});      
      }else{
         const startfrom = (this.state.page-1)*this.state.itemPerPage
         this.setState({
            totalPages:Math.ceil(data.length/this.state.itemPerPage),
            // data:resJSON.data,
            result:data.slice(startfrom,startfrom+this.state.itemPerPage),
            requests:false,
            startfrom:startfrom
         })

         // this.setState({result:this.state.data, requests:false});      
      }
   }
   render() {
      const { column, direction,requests, result } = this.state;
      return (
         <div>
            <div>                     
               <Menu>
                  <Menu.Item>
                     <Header>List data seluruh OPD</Header>
                  </Menu.Item>
                  <Menu.Item position="right">
                     <Input type="text"
                        icon="search"
                        placeholder="Pencarian..."
                        autoFocus 
                        value={this.state.query}
                        style={{width:'300px'}}
                        onChange={this.searchData.bind(this)} />
                  </Menu.Item>
               </Menu>
               {requests ? <Loader active inline='centered' /> :
                  <div id="data_print"><Segment>
                     <Table size='small' sortable celled>
                        <Table.Header>
                           <Table.Row>
                              <Table.HeaderCell>No.</Table.HeaderCell>
                              <Table.HeaderCell sorted={column === 'kode_opd' ? direction : null} onClick={this.handleSort('kode_opd')}>Kode OPD</Table.HeaderCell>
                              <Table.HeaderCell sorted={column === 'opd' ? direction : null} onClick={this.handleSort('opd')}>OPD</Table.HeaderCell>
                           </Table.Row>
                        </Table.Header>
                        <Table.Body>
                           {result.length===0 && 
                              <Table.Row>
                                 <Table.Cell colSpan="6">Data tidak ditemukan</Table.Cell>                           
                              </Table.Row>}
                           {result.map((item,i) => (
                              <Table.Row key={i}>               
                                 <Table.Cell>{this.state.startfrom+(i+1)}.</Table.Cell>
                                 <Table.Cell>{item.kode_opd}</Table.Cell>
                                 <Table.Cell>{item.opd}</Table.Cell>
                              </Table.Row>
                           ))}
                        </Table.Body>     
                        <Table.Footer fullWidth>
                           <Table.Row>
                              <Table.HeaderCell colSpan='3'>
                                 <Pagination activePage={this.state.activePage} 
                                    onPageChange={this.handlePaginationChange} 
                                    totalPages={this.state.totalPages}
                                 />
                              </Table.HeaderCell>
                           </Table.Row>
                        </Table.Footer>             
                     </Table></Segment>
                  </div>
               }
            </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/global/AllOPD.js